/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    BusinessCalendar,
    CalendarId,
    CalendarViewListDto,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getCalendarsId = (
    id: CalendarId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<BusinessCalendar>> => {
    return axios.get(`/api/calendars/${id}`, options);
};

export const getGetCalendarsIdQueryKey = (id: CalendarId) => {
    return [`/api/calendars/${id}`] as const;
};

export const getGetCalendarsIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getCalendarsId>>,
    TError = AxiosError<unknown>,
>(
    id: CalendarId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCalendarsId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCalendarsIdQueryKey(id);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getCalendarsId>>
    > = ({ signal }) => getCalendarsId(id, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: id !== null && id !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getCalendarsId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCalendarsIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCalendarsId>>
>;
export type GetCalendarsIdQueryError = AxiosError<unknown>;

export function useGetCalendarsId<
    TData = Awaited<ReturnType<typeof getCalendarsId>>,
    TError = AxiosError<unknown>,
>(
    id: CalendarId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCalendarsId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getCalendarsId>>,
                    TError,
                    Awaited<ReturnType<typeof getCalendarsId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalendarsId<
    TData = Awaited<ReturnType<typeof getCalendarsId>>,
    TError = AxiosError<unknown>,
>(
    id: CalendarId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCalendarsId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getCalendarsId>>,
                    TError,
                    Awaited<ReturnType<typeof getCalendarsId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalendarsId<
    TData = Awaited<ReturnType<typeof getCalendarsId>>,
    TError = AxiosError<unknown>,
>(
    id: CalendarId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCalendarsId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCalendarsId<
    TData = Awaited<ReturnType<typeof getCalendarsId>>,
    TError = AxiosError<unknown>,
>(
    id: CalendarId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCalendarsId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetCalendarsIdQueryOptions(id, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetCalendarsIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getCalendarsId>>,
    TError = AxiosError<unknown>,
>(
    id: CalendarId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCalendarsId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCalendarsIdQueryKey(id);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getCalendarsId>>
    > = ({ signal }) => getCalendarsId(id, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCalendarsId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCalendarsIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCalendarsId>>
>;
export type GetCalendarsIdSuspenseQueryError = AxiosError<unknown>;

export function useGetCalendarsIdSuspense<
    TData = Awaited<ReturnType<typeof getCalendarsId>>,
    TError = AxiosError<unknown>,
>(
    id: CalendarId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCalendarsId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalendarsIdSuspense<
    TData = Awaited<ReturnType<typeof getCalendarsId>>,
    TError = AxiosError<unknown>,
>(
    id: CalendarId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCalendarsId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalendarsIdSuspense<
    TData = Awaited<ReturnType<typeof getCalendarsId>>,
    TError = AxiosError<unknown>,
>(
    id: CalendarId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCalendarsId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCalendarsIdSuspense<
    TData = Awaited<ReturnType<typeof getCalendarsId>>,
    TError = AxiosError<unknown>,
>(
    id: CalendarId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCalendarsId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetCalendarsIdSuspenseQueryOptions(id, options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getCalendars = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<CalendarViewListDto>> => {
    return axios.get(`/api/calendars`, options);
};

export const getGetCalendarsQueryKey = () => {
    return [`/api/calendars`] as const;
};

export const getGetCalendarsQueryOptions = <
    TData = Awaited<ReturnType<typeof getCalendars>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getCalendars>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCalendarsQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendars>>> = ({
        signal,
    }) => getCalendars({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCalendars>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCalendarsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCalendars>>
>;
export type GetCalendarsQueryError = AxiosError<unknown>;

export function useGetCalendars<
    TData = Awaited<ReturnType<typeof getCalendars>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCalendars>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getCalendars>>,
                    TError,
                    Awaited<ReturnType<typeof getCalendars>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalendars<
    TData = Awaited<ReturnType<typeof getCalendars>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCalendars>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getCalendars>>,
                    TError,
                    Awaited<ReturnType<typeof getCalendars>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalendars<
    TData = Awaited<ReturnType<typeof getCalendars>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCalendars>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCalendars<
    TData = Awaited<ReturnType<typeof getCalendars>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCalendars>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetCalendarsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetCalendarsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getCalendars>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getCalendars>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCalendarsQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalendars>>> = ({
        signal,
    }) => getCalendars({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCalendars>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCalendarsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCalendars>>
>;
export type GetCalendarsSuspenseQueryError = AxiosError<unknown>;

export function useGetCalendarsSuspense<
    TData = Awaited<ReturnType<typeof getCalendars>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCalendars>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalendarsSuspense<
    TData = Awaited<ReturnType<typeof getCalendars>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCalendars>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalendarsSuspense<
    TData = Awaited<ReturnType<typeof getCalendars>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCalendars>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCalendarsSuspense<
    TData = Awaited<ReturnType<typeof getCalendars>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCalendars>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetCalendarsSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
